import * as Yup from "yup";

export const getVersionNoteValidator = (currentVersion?: number) =>
  currentVersion && currentVersion > 1
    ? Yup.string().required("Required").max(2000, "Max 2000 characters allowed")
    : Yup.mixed();
